import React, { Children } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function ReviewsSection() {
  const reviews = [{
    name: 'Carmen P., 31 años',
    text: '¡Increíble! Compré el kit por la noche y al instante ya tenía todo en mi correo. Imprimí las decoraciones en casa y en menos de una hora tenía todo listo. ¡Mi hija no podía creerlo!'
  }, {
    name: 'Marta L., 34 años',
    text: 'Los diseños son hermosos y súper fáciles de editar en Canva. Me encantó tener tantas temáticas disponibles para elegir la fiesta perfecta para mi pequeño.'
  }, {
    name: 'Elena V., 42 años',
    text: 'Todo llegó al momento y viene listo para imprimir. Seguí los tutoriales paso a paso y personalicé los toppers y las etiquetas sin ningún problema. ¡Repetiré seguro!'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 20
      }
    }
  };
  return <Section className="bg-white" data-id="element-190">
      <div className="text-center mb-10" data-id="element-191">
        <h2 className="text-3xl md:text-5xl font-black text-purple-700 uppercase tracking-tight" data-id="element-192">
          Lo que dicen nuestros clientes{' '}
          <span className="inline-flex gap-1 align-middle" data-id="element-193">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-7 h-7 md:w-9 md:h-9 text-yellow-400 fill-yellow-400 inline" data-id="element-194" />)}
          </span>
        </h2>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-195">
        {reviews.map((review, index) => <motion.div key={index} variants={itemVariants} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 text-center" data-id="element-196">
            <div className="flex justify-center gap-1 mb-4" data-id="element-197">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-198" />)}
            </div>
            <p className="text-gray-600 italic font-medium leading-relaxed mb-4" data-id="element-199">
              "{review.text}"
            </p>
            <p className="font-bold text-gray-800" data-id="element-200">— {review.name}</p>
          </motion.div>)}
      </motion.div>
    </Section>;
}